import { Alert, Empty, Pagination, Skeleton } from 'antd'
import { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { fetchPublicItems, type PublicApiError, type PublicItemSummary } from './publicApi'

const PAGE_SIZE = 24

export default function PublicItemListPage({ workspaceSlug, siteSlug }: { workspaceSlug: string; siteSlug: string }) {
  const [params, setParams] = useSearchParams()
  const page = Number(params.get('page') || '1')
  const [items, setItems] = useState<PublicItemSummary[] | null>(null)
  const [total, setTotal] = useState(0)
  const [error, setError] = useState<string | null>(null)
  const base = `/site/${workspaceSlug}/${siteSlug}`

  useEffect(() => {
    setItems(null)
    setError(null)
    fetchPublicItems(workspaceSlug, siteSlug, { page, page_size: PAGE_SIZE })
      .then((r) => {
        setItems(r.data.items)
        setTotal(r.data.total)
      })
      .catch((err) => setError((err as PublicApiError).message))
  }, [workspaceSlug, siteSlug, page])

  if (error) return <div className="pub-page"><Alert type="error" message={error} showIcon /></div>

  return (
    <div className="pub-page">
      <h1>条目</h1>
      {items === null ? (
        <Skeleton active paragraph={{ rows: 6 }} />
      ) : items.length === 0 ? (
        <Empty className="pub-empty" description="暂无条目" />
      ) : (
        <>
          <div className="pub-grid" style={{ marginTop: 24 }}>
            {items.map((item) => (
              <Link key={item.slug} to={`${base}/items/${item.slug}`} className="pub-card">
                <div className="pub-card-cover">
                  {item.cover_url && <img src={item.cover_url} alt={item.label} />}
                  {item.category && <span className="pub-card-badge">{item.category.name}</span>}
                </div>
                <div className="pub-card-body">
                  <p className="pub-card-title">{item.label}</p>
                  <p className="pub-card-meta">{item.creator || item.era || item.accession_number}</p>
                </div>
              </Link>
            ))}
          </div>
          {total > PAGE_SIZE && (
            <div style={{ marginTop: 32, textAlign: 'center' }}>
              <Pagination
                current={page}
                pageSize={PAGE_SIZE}
                total={total}
                onChange={(p) => setParams({ page: String(p) })}
                showSizeChanger={false}
              />
            </div>
          )}
        </>
      )}
    </div>
  )
}
